import { render, staticRenderFns } from "./ItemListPremiumMarketCreate.vue?vue&type=template&id=cd019cd4&scoped=true"
import script from "./ItemListPremiumMarketCreate.vue?vue&type=script&lang=js"
export * from "./ItemListPremiumMarketCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd019cd4",
  null
  
)

export default component.exports